import styled, { css } from "styled-components";

interface ItemActiveProps {
  active: boolean;
}

export const BottomNavItem = styled.li<ItemActiveProps>`
  display: flex;
  width: 100%;
  height: 54px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 4px;
  gap: 2px;

  ${(props) =>
    props.active &&
    css`
      background: ${(props) => props.theme.colors.whiteActive};
      color: ${(props) => props.theme.colors.primary};
      font-weight: 600;

      svg {
        path {
          fill: ${(props) => props.theme.colors.primary};
        }
      }
    `}

  &:active {
    background: ${(props) => props.theme.colors.whiteActive};
    color: ${(props) => props.theme.colors.primary};
    font-weight: 600;

    svg {
      path {
        fill: ${(props) => props.theme.colors.primary};
      }
    }
  }
`;

export const NavItemIcon = styled.div`
  svg {
    width: 18px;
    height: 18px;
  }
`;

export const NavItemTit = styled.span`
  font-size: 1.1rem;
`;
